import React from 'react';
import Select from '../Select';
import FieldError from '../FieldError';
import FieldWrapper from '../FieldWrapper';
import Label from '../Label';

// eslint-disable-next-line
const FormikInputField = ({ field, type, form, options, label, onChange, hidden, ...other }) => {
  const findOptionByValue = (value) => {
    if (Array.isArray(value)) {
      return options.filter((option) => value.includes(option.value));
    }
    return options.find((option) => option.value === value);
  };

  const defaultValue = Array.isArray(field.value)
    ? field.value.map((val) => findOptionByValue(val))
    : findOptionByValue(field.value);

  return (
    <FieldWrapper hidden={hidden}>
      {label && <Label>{label}</Label>}
      <Select
        hasError={(field.name in form.touched) && (field.name in form.errors)}
        options={options}
        name={field.name}
        defaultValue={defaultValue}
        value={options ? findOptionByValue(field.value) : ''}
        onChange={(selected) => {
          let newValue = null;
          if (Array.isArray(selected)) {
            newValue = selected.map((x) => x.value);
          } else if (selected && selected.value) {
            newValue = selected.value;
          }
          form.setFieldValue(field.name, newValue);
          onChange({ form, selected });
        }}
        onBlur={field.onBlur}
        {...other}
      />
      {form.errors[field.name] && form.touched[field.name]
        && <FieldError>{form.errors[field.name]}</FieldError>}
    </FieldWrapper>

  );
};
FormikInputField.defaultProps = {
  onChange: () => {},
};

export default FormikInputField;
